"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomainTheme = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _abyss = require("./variants/abyss");
var _optum = require("./variants/optum");
var _uhc = require("./variants/uhc");
var _uhg = require("./variants/uhg");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var THEME_VARIANTS = {
  abyss: {
    theme: _abyss.abyss
  },
  optum: {
    theme: _optum.optum,
    match: /^(?:[a-zA-Z0-9-]+\.)*optum\.com\/?$/
  },
  uhc: {
    theme: _uhc.uhc,
    match: /^(?:[a-zA-Z0-9-]+\.)*(?:uhc\.com|uhcprovider\.com)\/?$/
  },
  uhg: {
    theme: _uhg.uhg,
    match: /^(?:[a-zA-Z0-9-]+\.)*(?:uhg\.com|unitedhealthgroup\.com)\/?$/
  }
};
var getDomainTheme = function getDomainTheme(name) {
  var domainTheme;
  if (name && THEME_VARIANTS[name]) {
    return _objectSpread(_objectSpread({}, THEME_VARIANTS[name]), {}, {
      name: name
    });
  }
  if (typeof window !== 'undefined') {
    var domain = window.location.host;
    Object.keys(THEME_VARIANTS).forEach(function (key) {
      var regex = THEME_VARIANTS[key].match;
      if (regex && regex.test(domain)) {
        domainTheme = _objectSpread(_objectSpread({}, THEME_VARIANTS[key]), {}, {
          name: key
        });
      }
    });
  }
  if (!domainTheme) {
    domainTheme = {
      theme: _abyss.abyss,
      name: 'abyss'
    };
  }
  return domainTheme;
};
exports.getDomainTheme = getDomainTheme;